import { MantineTheme, rem } from "@mantine/core";
import { rgba } from "polished";

import { ThemeComponent } from "./helpers";

const pagination = (theme: MantineTheme) => ({
  control: {
    fontSize: rem(14),
    lineHeight: 1.5,
    padding: 0,
    "&[data-active]": {
      background: theme.colors.dusk[0],
      border: 0,
      "&:hover": {
        background: `${rgba(theme.colors.dusk[0], 0.9)}!important`,
      },
    },
  },
});

export default function paginationTheme(): ThemeComponent {
  return {
    styles: (theme) => ({
      ...pagination(theme),
    }),
  };
}
